import { handlePortalError } from '../utils';

import { MonitoringAPI } from '../../api/monitoring.api';

import type { AppThunk } from '../../types/state.types';

// All of these are not really thunks, just API calls with error handling

export const MonitoringActions = {
  getSubscriptionStats(subId: string, handleError = true): AppThunk {
    return function (dispatch, getState) {
      const portalUrl = getState().globals.portalUrl;
      return MonitoringAPI.getSubscriptionStats(portalUrl, subId).catch((error) => {
        if (handleError) return dispatch(handlePortalError(error));
        else throw error;
      });
    };
  },
  getInvoiceData(subId: string, handleError = true): AppThunk {
    return function (dispatch, getState) {
      const portalUrl = getState().globals.portalUrl;
      return MonitoringAPI.getInvoiceData(portalUrl, subId).catch((error) => {
        if (handleError) return dispatch(handlePortalError(error));
        else throw error;
      });
    };
  },
};
